import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const updateContractFiscalDetailsSchema = z.object({
  contract: z.object({
    fiscal_document_requirement: optionSchema,
    fiscal_document_consumer: optionSchema,
  }),
})

export type UpdateContractFiscalDetailsSchema = z.infer<typeof updateContractFiscalDetailsSchema>
